import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addCustomerApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const addCustomer = createAsyncThunk('addCustomer', async (payload) => {
  return await addCustomerApi(payload);
});

const addCustomerSlice = createSlice({
  name: 'addCustomer', // Unique Name
  initialState,
  reducers: {
    addCustomerReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addCustomer.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(addCustomer.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(addCustomer.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { addCustomerReset } = addCustomerSlice.actions;

export default addCustomerSlice.reducer;
